<template>
    <UIRadioGroup v-model="brand">
        <div class="brand-radio__group">
            <UIRadioImage
                id="brand_hyundai"
                :value="'hyundai'"
                :image-src="brandHyundaiImage"
                label="Hyundai"
                class="brand-radio__hyundai"
            />

            <UIRadioImage
                id="brand_genesis"
                :value="'genesis'"
                :image-src="brandGenesisImage"
                label="Genesis"
                class="brand-radio__genesis"
            />
        </div>
    </UIRadioGroup>

    <span v-if="errorMessage" class="form-field__error">
        {{ errorMessage }}
    </span>
</template>

<script lang="ts" setup>
    import brandHyundaiImage from '@/assets/icons/ui/brands/brand-hyundai.svg';
    import brandGenesisImage from '@/assets/icons/ui/brands/brand-genesis.svg';

    import UIRadioGroup from '@/components/ui/UIRadioGroup/UIRadioGroup.vue';
    import UIRadioImage from '@/components/ui/UIRadioImage/UIRadioImage.vue';

    const { errorMessage } = defineProps<{
        errorMessage: string,
    }>();

    const brand = defineModel<string | undefined>({
        default: undefined,
    });
</script>

<style scoped lang="scss">
    @use './UIBrandImageableRadio.scss' as *;
</style>
